/** Custom sort order: Ahead → Ontime → Laggard(s) / Behind (asc). */

export type TimelinessSortDirection = "asc" | "desc" | "ascending" | "descending";

const TIMELINESS_RANK: Record<string, number> = {
  ahead: 0,
  ontime: 1,
  ontrack: 1,
  laggard: 2,
  laggards: 2,
  behind: 2,
};

export const getTimelinessSortRank = (value: string | null | undefined): number => {
  if (value === null || value === undefined || value === "") {
    return Number.MAX_SAFE_INTEGER;
  }

  const normalized = value.toString().trim().toLowerCase().replace(/[\s_-]+/g, "");

  if (normalized in TIMELINESS_RANK) {
    return TIMELINESS_RANK[normalized];
  }

  if (normalized.includes("ahead")) return TIMELINESS_RANK.ahead;
  if (
    normalized.includes("ontime") ||
    normalized.includes("ontrack")
  ) {
    return TIMELINESS_RANK.ontime;
  }
  if (normalized.includes("laggard") || normalized.includes("behind")) {
    return TIMELINESS_RANK.laggard;
  }

  return Number.MAX_SAFE_INTEGER;
};

export const compareTimeliness = (
  a: string | null | undefined,
  b: string | null | undefined,
  direction: string
): number => {
  const isAsc = direction === "asc" || direction === "ascending";
  const rankA = getTimelinessSortRank(a);
  const rankB = getTimelinessSortRank(b);

  if (rankA !== rankB) {
    return isAsc ? rankA - rankB : rankB - rankA;
  }

  const labelA = (a ?? "").toString();
  const labelB = (b ?? "").toString();
  return isAsc ? labelA.localeCompare(labelB) : labelB.localeCompare(labelA);
};

export const isTimelinessSortField = (field: string): boolean =>
  field === "Performance_Type" || field === "Progress";
